import { AlphaProgramScreen } from '@/screens/alpha-program/alpha-program-screen';
export default AlphaProgramScreen;
